if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = document.getElementById(`ProductStickyAtc-Button-${this.sectionId}`);
        this.stickyPrice = document.getElementById(`ProductStickyAtc-Price-${this.sectionId}`);
        this.stickyImage = document.getElementById(`ProductStickyAtc-Image-${this.sectionId}`);
        this.stickyButtonText = this.stickyButton?.querySelector('.product-sticky-atc__button-text');

        if (!this.submitButton || !this.stickyButton) return;

        this.defaultButtonText = this.stickyButtonText?.textContent?.trim() || 'Agregar';

        this.stickyButton.addEventListener('click', this.onStickyButtonClick.bind(this));

        this.observeTarget = this.submitButton.closest('.product-form__buttons-row') || this.submitButton;

        this.observer = new IntersectionObserver(this.onSubmitVisibilityChange.bind(this), {
          root: null,
          threshold: 0,
          rootMargin: '0px 0px 0px 0px',
        });
        this.observer.observe(this.observeTarget);

        this.submitObserver = new MutationObserver(this.syncButtonStateFromDOM.bind(this));
        this.submitObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          subtree: true,
          childList: true,
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.submitObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
      }

      onSubmitVisibilityChange([entry]) {
        const isVisible = !entry.isIntersecting;
        this.classList.toggle('is-visible', isVisible);
      }

      onStickyButtonClick() {
        if (this.stickyButton.disabled || this.stickyButton.classList.contains('loading')) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.submitButton.disabled) return;

        this.stickyButton.classList.add('loading');
        if (this.stickyButtonText) {
          this.stickyButtonText.textContent =
            this.stickyButtonText.dataset.textLoading || 'Agregando';
        }

        const clearLoading = () => {
          this.stickyButton.classList.remove('loading');
          if (this.stickyButtonText) {
            this.stickyButtonText.textContent = this.defaultButtonText;
          }
        };
        const loadingObserver = new MutationObserver(() => {
          if (!this.submitButton.classList.contains('loading')) {
            loadingObserver.disconnect();
            clearLoading();
          }
        });

        loadingObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['class', 'aria-disabled'],
        });

        this.submitButton.click();
        setTimeout(() => {
          loadingObserver.disconnect();
          clearLoading();
        }, 5000);
      }

      onVariantChange({ data }) {
        if (String(data.sectionId) !== String(this.sectionId)) return;

        if (data.variant) {
          this.updatePrice(data.html);
          this.updateImage(data.variant);
        }

        this.syncButtonState(data.html);
      }

      updatePrice(html) {
        if (!this.stickyPrice) return;

        const priceSource = html.getElementById(`price-${this.sectionId}`);
        if (!priceSource) return;

        const salePrice = priceSource.querySelector(
          '.product-price-custom__sale-price, .product-price-custom__regular-price'
        );

        if (salePrice) {
          const comparePrice = priceSource.querySelector('.product-price-custom__compare s');
          const compareHtml = comparePrice
            ? `<span class="product-sticky-atc__compare"><s>${comparePrice.textContent.trim()}</s></span>`
            : '';
          this.stickyPrice.innerHTML = `${compareHtml}<span class="cross-selling__price">${salePrice.textContent.trim()}</span>`;
          return;
        }

        const soldOut = priceSource.querySelector('.product-price-custom__sold-out');
        if (soldOut) {
          this.stickyPrice.innerHTML = `<span class="cross-selling__price">${soldOut.textContent.trim()}</span>`;
        }
      }

      updateImage(variant) {
        if (!this.stickyImage || !variant?.featured_media?.preview_image?.src) return;
        this.stickyImage.src = variant.featured_media.preview_image.src;
        if (variant.featured_media.preview_image.alt) {
          this.stickyImage.alt = variant.featured_media.preview_image.alt;
        }
      }

      syncButtonState(html) {
        const submitButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const isDisabled = submitButton?.hasAttribute('disabled') ?? true;
        const submitText = submitButton?.querySelector('.product-form__submit-text')?.textContent?.trim();

        this.stickyButton.disabled = isDisabled;
        this.stickyButton.classList.toggle('cross-selling__add-btn--disabled', isDisabled);

        if (this.stickyButtonText) {
          this.stickyButtonText.textContent = isDisabled && submitText ? submitText : this.defaultButtonText;
        }
      }

      syncButtonStateFromDOM() {
        const isDisabled =
          this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true';
        const submitText = this.submitButton.querySelector('.product-form__submit-text')?.textContent?.trim();

        this.stickyButton.disabled = isDisabled;
        this.stickyButton.classList.toggle('cross-selling__add-btn--disabled', isDisabled);

        if (this.stickyButtonText) {
          this.stickyButtonText.textContent = isDisabled && submitText ? submitText : this.defaultButtonText;
        }
      }
    }
  );
}
